'use strict';

export default class StatusCheckRedirector {

    /**
     * Checks a URL asynchronously and re-direct if response is true
     *
     * @param {string} urlToCheck
     * @param {string} urlToRedirectTo
     * @param {int} millisecondsToWait
     */
    static startChecking(
        urlToCheck,
        urlToRedirectTo,
        millisecondsToWait
    ) {
        let redirecting = false;
        function makeAjaxStatusCheckCall() {
            if (redirecting) {
                return;
            }

            let lastTimeout;
            $.ajax({
                type: 'GET',
                url: urlToCheck,
                dataType: 'json',
                success: function (result) {
                    if (typeof(result) === "boolean" && result === true) {
                        redirecting = true;
                        clearTimeout(lastTimeout);
                        window.location.href = urlToRedirectTo;
                    }
                },
                complete: function () {
                    if (redirecting) {
                        return;
                    }
                    lastTimeout = setTimeout(makeAjaxStatusCheckCall, millisecondsToWait);
                }
            });
        }

        makeAjaxStatusCheckCall();
    }
}

// Initialize the class against the processing page
const statusCheckEl = $('.js-status-check-redirector');

if (statusCheckEl.length > 0) {
    const urlToCheck = statusCheckEl.data('url-to-check'),
          urlToRedirectTo = statusCheckEl.data('url-to-redirect-to'),
          millisecondsToWait = 1000;

    new StatusCheckRedirector.startChecking(urlToCheck, urlToRedirectTo, millisecondsToWait);
}




// WEBPACK FOOTER //
// ./src/js/components/status-check-redirector.js